import type { ReactNode } from 'react';
import type { StructuredContent } from './hydration/types';

type ComponentProps = Record<string, Record<string, unknown>>;

type RenderDoc = StructuredContent | StructuredContent[];

type RenderFn = (
  doc: RenderDoc,
  useLearnContentOverrides?: boolean,
  componentProps?: ComponentProps,
) => ReactNode;

let renderFunction: RenderFn | null = null;
let currentOverrides: boolean | undefined;

export function setRenderer(fn: RenderFn) {
  renderFunction = fn;
}

export function renderStructuredContent(
  doc: RenderDoc,
  useLearnContentOverrides?: boolean,
  componentProps?: ComponentProps,
): ReactNode {
  if (!renderFunction) {
    throw new Error('Renderer not initialized. Call setRenderer() first.');
  }
  if (useLearnContentOverrides !== undefined) {
    currentOverrides = useLearnContentOverrides;
  }
  return renderFunction(doc, currentOverrides, componentProps);
}
